import React from 'react';
import { Card, Typography, Progress } from 'antd';
import { LoadingOutlined, CheckCircleOutlined, ArrowRightOutlined } from '@ant-design/icons';
import './ProcessingLoader.css';

const { Text, Title } = Typography;

const ProcessingLoader = ({ 
  visible, 
  stage = 'captcha', // 'captcha', 'processing', 'redirecting'
  message = '' 
}) => {
  if (!visible) return null;

  const getStageInfo = () => {
    switch (stage) {
      case 'captcha':
        return {
          icon: <LoadingOutlined style={{ fontSize: 24, color: '#1890ff' }} />,
          title: 'Resolviendo Captcha',
          description: 'Estamos resolviendo el captcha del sistema de Tesorería. Este proceso puede tomar entre 2-5 minutos dependiendo de la carga del servidor...',
          progress: 25
        };
      case 'processing':
        return {
          icon: <LoadingOutlined style={{ fontSize: 24, color: '#52c41a' }} />,
          title: 'Procesando Formulario',
          description: 'Procesando y enviando el formulario F23 al sistema de Tesorería...',
          progress: 75
        };
      case 'redirecting':
        return {
          icon: <ArrowRightOutlined style={{ fontSize: 24, color: '#722ed1' }} />,
          title: 'Redirigiendo al Pago',
          description: 'Redirigiendo a la página de pago de Tesorería...',
          progress: 100
        };
      default:
        return {
          icon: <LoadingOutlined style={{ fontSize: 24, color: '#1890ff' }} />,
          title: 'Procesando',
          description: 'Procesando solicitud...',
          progress: 50
        };
    }
  };

  const stageInfo = getStageInfo();

  return (
    <div className="processing-loader-overlay">
      <Card className="processing-loader-card">
        <div className="processing-loader-content">
          <div className="processing-loader-icon">
            {stageInfo.icon}
          </div>
          
          <Title level={4} className="processing-loader-title">
            {stageInfo.title}
          </Title>
          
          <Text className="processing-loader-description">
            {message || stageInfo.description}
          </Text>
          
          <div className="processing-loader-progress">
            <Progress 
              percent={stageInfo.progress} 
              showInfo={false}
              strokeColor={{
                '0%': '#108ee9',
                '100%': '#87d068',
              }}
            />
          </div>
          
          <div className="processing-loader-steps">
            <div className={`step ${stage === 'captcha' ? 'active' : stage === 'processing' || stage === 'redirecting' ? 'completed' : ''}`}>
              <CheckCircleOutlined className="step-icon" />
              <span>Captcha</span>
            </div>
            <div className={`step ${stage === 'processing' ? 'active' : stage === 'redirecting' ? 'completed' : ''}`}>
              <CheckCircleOutlined className="step-icon" />
              <span>Procesando</span>
            </div>
            <div className={`step ${stage === 'redirecting' ? 'active' : ''}`}>
              <CheckCircleOutlined className="step-icon" />
              <span>Redirigiendo</span>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default ProcessingLoader;
